/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Delivery: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23.1288 4.00772C23.4249 4.04615 23.6911 4.21677 23.8505 4.47451C24.0097 4.73231 24.0422 5.04604 23.9442 5.32802L23.8944 5.44716L21.9999 9.23618V19.9997C21.9999 20.552 21.5522 20.9997 20.9999 20.9997H3.00012C2.44795 20.9996 2.00013 20.552 2.00013 19.9997V9.23618L0.105623 5.44716L0.0646075 5.35341C-0.114942 4.87957 0.0899155 4.33691 0.552884 4.10537C1.01589 3.87387 1.57252 4.03584 1.84389 4.46377L1.89467 4.55264L3.61828 7.99987H9.3819L11.1055 4.55264L11.1768 4.43154C11.3617 4.16367 11.6687 3.99998 12 3.99991H22.9999L23.1288 4.00772ZM4.00011 18.9998H9.00006V9.99985H4.00011V18.9998ZM11 18.9998H20V9.99985H11V18.9998ZM11.6182 7.99987H20.3818L21.3818 5.99989H12.6182L11.6182 7.99987Z'
      fill='currentColor'
    />
  </React.Fragment>
)
